import React from 'react';
import { X, Zap } from 'lucide-react';
import { QuickEstimateWizard } from '../pages/QuickEstimatePage';

export default function QuickEstimateDrawer({ open, onClose }) {
  if (!open) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/30 z-40 transition-opacity"
        onClick={onClose}
        data-testid="quick-drawer-overlay"
      />
      {/* Drawer */}
      <div
        className="fixed right-0 top-0 h-full w-full max-w-md bg-white z-50 shadow-2xl flex flex-col animate-in slide-in-from-right"
        data-testid="quick-estimate-drawer"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-gradient-to-br from-[#4ABFCF] to-[#0F2040] flex items-center justify-center">
              <Zap className="w-3 h-3 text-white" />
            </div>
            <span className="text-sm font-semibold text-[#0F2040] font-['Outfit']">Quick Estimate</span>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-md hover:bg-slate-100 transition-colors text-slate-400 hover:text-slate-600"
            data-testid="quick-drawer-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-y-auto px-5 py-5">
          <QuickEstimateWizard onClose={onClose} isDrawer />
        </div>
      </div>
    </>
  );
}
